import { Dropdown } from "antd";
import { DropdownButtonProps, DropdownProps } from "./type";

function AntDropdown(props: DropdownProps) {
  return <Dropdown {...props} />;
}

function AntDropdownButton(props: DropdownButtonProps) {
  return <Dropdown.Button {...props} />;
}

export { AntDropdown as Dropdown, AntDropdownButton as DropdownButton };
